// extracted by mini-css-extract-plugin
export default {"layout":"ErrorModal_layout__e6ATM","header":"ErrorModal_header__5KD5s","content":"ErrorModal_content__b+PX+","footer":"ErrorModal_footer__8XJOg"};